module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add Stakeholder","placeholder":"Search stakeholders","btnSubmit":"Save","btnCancel":"Cancel","name":"Name","description":"Description"},"de":{"title":"Stakeholder hinzufügen","placeholder":"Stakeholder suchen","btnSubmit":"Speichern","btnCancel":"Abbrechen","name":"Name","description":"Beschreibung"}}')
  delete Component.options._Ctor
}
